var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImagePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.811 52.48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".image-placeholder_svg__cls-1{fill:inherit}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-placeholder_svg__drawing",
    transform: "translate(-61.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "image-placeholder_svg__Path_31365",
    "data-name": "Path 31365",
    className: "image-placeholder_svg__cls-1",
    d: "M101.16 9.884L91.727.45A1.537 1.537 0 0090.64 0h-27.3a1.538 1.538 0 00-1.54 1.537v49.4a1.538 1.538 0 001.537 1.537h36.736a1.538 1.538 0 001.537-1.537V10.971a1.538 1.538 0 00-.45-1.087zM64.875 49.4V3.075H89.1v7.9a1.538 1.538 0 001.537 1.537h7.9V49.4zm27.3-39.971v-4.18l4.184 4.184z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image-placeholder_svg__Path_31366",
    "data-name": "Path 31366",
    className: "image-placeholder_svg__cls-1",
    d: "M143.578 143.147a5.149 5.149 0 10-5.149 5.149 5.155 5.155 0 005.149-5.149zm-5.149-2.074a2.074 2.074 0 11-2.074 2.074 2.077 2.077 0 012.073-2.074z",
    transform: "translate(-64.152 -123.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image-placeholder_svg__Path_31367",
    "data-name": "Path 31367",
    className: "image-placeholder_svg__cls-1",
    d: "M166.668 241.68a1.538 1.538 0 00-2.552 0l-8.81 13.107a1.538 1.538 0 001.276 2.4H174.2a1.538 1.538 0 001.276-2.4zm-7.2 12.427l5.924-8.814 5.924 8.814z",
    transform: "translate(-83.686 -216.298)"
  }))));
}

export default SvgImagePlaceholder;